import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';

interface PredefinedDateRangesProps {
  startDate: string;
  endDate: string;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  oldestAppliedISO?: string | null;
}

const PredefinedDateRanges: React.FC<PredefinedDateRangesProps> = ({
  startDate,
  endDate,
  onDateRangeChange,
   oldestAppliedISO,
}) => {
  // Set Monday as the first day of the week
  useEffect(() => {
    moment.updateLocale('en', {
      week: { dow: 1 },
    });
  }, []);

  // Parse incoming strings to moment objects
  const start = moment(startDate);
  const end = moment(endDate);

  const handleCallback = (start: moment.Moment, end: moment.Moment) => {
    onDateRangeChange(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
  };

  const label = `${start.format('DD MMM')} - ${end.format('DD MMM')}`;

  return (
    <DateRangePicker
      initialSettings={{
        startDate: start.toDate(),
        endDate: end.toDate(),
        minDate: oldestAppliedISO ? moment(oldestAppliedISO).toDate() : undefined, // works
        ranges: {
          Today: [moment().toDate(), moment().toDate()],
          Yesterday: [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
          'This Week': [
            moment().startOf('isoWeek').toDate(),
            moment().endOf('isoWeek').toDate(),
          ],
          'Last Week': [
            moment().subtract(1, 'week').startOf('isoWeek').toDate(),
            moment().subtract(1, 'week').endOf('isoWeek').toDate(),
          ],
          'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
          ],
        },
      }}
      onCallback={handleCallback}
    >
      <div id="reportrange daterangepicker" className="new-date">
        <span>{label}</span>
      </div>
    </DateRangePicker>
  );
};

export default PredefinedDateRanges;